import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { getWorkstations } from "../Api";
import ZionLogo from "../components/ZionLogo";
import DashboardShortcuts from "../components/DashboardShortcuts";
import ReportsShortcuts from "../components/ReportsShortcuts";
import AlarmsShortcuts from "../components/AlarmsShortcuts";
import AdminShortcuts from "../components/AdminShortcuts";
import DeviceTypeChartPanel from "../components/DeviceTypeChartPanel";
import HomeKpiTiles from "../components/HomeKpiTiles";
import OsVersionChart from "../components/OsVersionChart";
import {
  NeedsAttentionPanel,
  RecentDevicesPanel,
} from "../components/DeviceListPanels";
import "./Home.css";

const sectionVariants = {
  hidden: { opacity: 0, y: 24 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { type: "spring", stiffness: 180, damping: 24 },
  },
};

const Section = ({ title, children }) => (
  <motion.section
    className="home-section"
    variants={sectionVariants}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, margin: "-60px" }}
  >
    <h2 className="home-section__title">
      <span className="home-section__bar" />
      {title}
    </h2>
    {children}
  </motion.section>
);

function HomePage() {
  const [t] = useTranslation();
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getWorkstations().then((data) => {
      setDevices(Array.isArray(data) ? data : []);
      setLoading(false);
    });
  }, []);

  return (
    <div className="home-view">
      <motion.div
        className="home-hero"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ type: "spring", stiffness: 160, damping: 22 }}
      >
        <span className="home-hero__mark">
          <ZionLogo size={30} />
        </span>
        <div className="home-hero__text">
          <h1>{t("auth-form.welcome")}</h1>
          <p>{t("auth-form.brand-tagline")}</p>
        </div>
      </motion.div>

      <HomeKpiTiles devices={devices} />

      <Section title={t("main-sidebar.dashboard")}>
        <DashboardShortcuts />
      </Section>

      <Section title={t("device-type-chart-panel.devices-by-type")}>
        <DeviceTypeChartPanel devices={devices} loading={loading} />
      </Section>

      <Section title={t("home.os-versions")}>
        <OsVersionChart devices={devices} />
      </Section>

      <Section title={t("home.overview")}>
        <div className="home-ops">
          <NeedsAttentionPanel devices={devices} />
          <RecentDevicesPanel devices={devices} />
        </div>
      </Section>

      <Section title={t("main-sidebar.reports")}>
        <ReportsShortcuts />
      </Section>

      <Section title={t("main-sidebar.alarms")}>
        <AlarmsShortcuts />
      </Section>

      <Section title={t("main-sidebar.admin")}>
        <AdminShortcuts />
      </Section>
    </div>
  );
}

export default HomePage;
